import { render } from "./takat-tabs.vue?vue&type=template&id=742ceacd&scoped=true"
import script from "./takat-tabs.vue?vue&type=script&lang=js"
export * from "./takat-tabs.vue?vue&type=script&lang=js"

import "./takat-tabs.vue?vue&type=style&index=0&id=742ceacd&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-742ceacd"]])

export default __exports__